import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  headline() {
    return faker.lorem.sentence();
  },

  subheadline() {
    return faker.lorem.sentence();
  },

  afterCreate(audioplayer, server) {
    audioplayer.update({
      artist: server.create('artist'),
      tracks: server.createList('audioplayer-track', 1),
    });
  },
});
